<div class="container p-gutter grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-4 pb-3">
    <app-card-box icon="mat:featured_play_list" iconClass="text-primary bg-primary/10" label="Total Examinations"
        value='{{dashData.examCount}}'></app-card-box>

    <app-card-box icon="mat:featured_play_list" iconClass="text-primary bg-primary/10" label="Written Examinations"
        value='{{dashData.writtenCount}}'></app-card-box>

    <app-card-box icon="mat:featured_play_list" iconClass="text-primary bg-primary/10" label="Pending Examinations"
        value='{{dashData.pendingCount}}'></app-card-box>

    <app-card-box icon="mat:featured_play_list" iconClass="text-primary bg-primary/10" label="Ongoing Examinations"
        value='{{dashData.ongoingCount}}'></app-card-box>

    <app-card-box icon="mat:group" iconClass="text-primary bg-primary/10" label="Total Candidates"
        value='{{dashData.candidateCount}}'></app-card-box>
</div>

<div class="container p-gutter">
    <div class="layout-padding">
        <div class="row">
            <div class="col-md-6">
                <h4 class="text-muted">Today's Examinations</h4>
                <hr>
                <div class="container" *ngFor="let tex of dashData.todaysExamination,let i = index">
                    <h5 class="mb-1"><b>{{i+1}}. </b> {{tex.examinationName}}</h5>
                    <div class="">Date: {{GetDate(tex.examStartDate)}} -
                        {{GetDate(tex.examEndDate)}}</div>
                    <div>Candidates: {{tex.scheduledCount}}</div>
                    <hr>
                </div>
                <h6 class="p-2 text-center text-warning" *ngIf="dashData.todaysExamination.length<=0">
                    No Examination
                </h6>
                <a href="/exams" class="ml-5" *ngIf="dashData.todaysExamination.length>0">Veiw all</a>
            </div>
            <div class="col-md-6">
                <h4 class="text-muted">Upcoming Examinations</h4>
                <hr>
                <div class="container" *ngFor="let tex of dashData.upcomingExaminations,let i = index">
                    <h5 class="mb-1"><b>{{i+1}}. </b> {{tex.examinationName}}</h5>
                    <div class="">Date: {{GetDate(tex.examStartDate)}} -
                        {{GetDate(tex.examEndDate)}}</div>
                    <div>Candidates: {{tex.scheduledCount}}</div>
                    <hr>
                </div>
                <h6 class="p-2 text-center text-warning" *ngIf="dashData.upcomingExaminations.length<=0">
                    No Examination
                </h6>

                <a href="/exams" class="ml-5" *ngIf="dashData.upcomingExaminations.length>0">Veiw all</a>

            </div>
        </div>


        <h4 class="text-muted mt-3">Recently Concluded Examinations</h4>
        <hr>
        <div class="row row-cols-2">
            <div class="col" *ngFor="let tex of dashData.concludedExaminations  ,let i = index">
                <h5 class="mb-1"><b>{{i+1}}. </b> {{tex.examinationName}}</h5>
                <div class="">Date: {{GetDate(tex.examStartDate)}} -
                    {{GetDate(tex.examEndDate)}}</div>
                <div>Candidates: {{tex.scheduledCount}}</div>
                <hr>
            </div>
            <h6 class="p-2 text-center text-warning" *ngIf="dashData.concludedExaminations.length<=0">
                No Examination
            </h6>

            <a href="/exams" class="ml-5" *ngIf="dashData.concludedExaminations.length>0">Veiw all</a>

        </div>
    </div>